/*
 * @Description: 产品及产品管理有关语言包
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  产品: 'Product',
  新增产品: 'Add Product',
  价格信息: 'Price Information',
  编辑产品: 'Edit Product',
  新增价格: 'Add Price',
  编辑价格: 'Edit Price',
  认缴信息: 'Subscribed Information',
  实缴信息: 'Paid-up Information'
};
